const AngleRightOutlined = ({ size = 14, fill = '#25314C' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 14 14'
  >
    <path
      fill={fill}
      d='M5.833 9.771a.438.438 0 0 1-.31-.747L7.549 7 5.524 4.976a.438.438 0 1 1 .619-.62L8.476 6.69c.17.17.17.448 0 .619L6.143 9.642a.44.44 0 0 1-.31.13'
    />
  </svg>
);

export default AngleRightOutlined;
